import HeaderLayout from '../../../Layout/HeaderLayout';
import { episodes } from '../../../Services/episodes';
import { IPlaylist } from '../../../Models/IEpisode';
import { useDispatch, useSelector } from 'react-redux';
import { IState, actions } from '../../../Store/reducer';
import { useState } from 'react';
import { PlainBox } from '../../../Components/PlainBox';
import '../../../Components/Playlist/playlist.scss';

export default function PlaylistMaster() {

    const { episodeNumber, sceneNumber, playlistId, isPlaying } = useSelector((state: IState) => state.master);
    const [activePlaylist, setActivePlaylist] = useState<any>(playlistId ?
        episodes[episodeNumber].scene[sceneNumber].playlists.find((p: any) => p.playlistId === playlistId) : "");

    const dispatch = useDispatch();

    function setPlaylistId(playlistId: string) {
        dispatch({
            type: actions.master.SET_PLAYLIST_ID,
            payload: {
                master: {
                    playlistId: playlistId,
                }
            },
        });
    }

    function setIsPlaying(bool: boolean) {
        dispatch({
            type: actions.master.SET_IS_PLAYING,
            payload: {
                master: {
                    isPlaying: bool,
                }
            },
        });
    }

    function onPlaylistBlockClick(playlist: { label: string, icon: string, playlistId: string }) {
        setIsPlaying(!isPlaying);
        if (!activePlaylist || playlist.playlistId !== activePlaylist.playlistId) {
            setActivePlaylist(playlist);
            setPlaylistId(playlist.playlistId);
        }
    }

    return (
        <div className="master-playlist">
            <HeaderLayout currentPage="playlist" hamburger={true} isMaster={true}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 116.43 100"><g id="Mode_Isolation"><rect fill="#fff" x="48.86" y="77.46" width="67.57" height="7.51" rx="2.73" ry="2.73" /><path fill="#fff" d="m67.69,17.9V4.13c.01-2.76-2.65-4.74-5.29-3.95l-29.41,8.8c-1.74.52-2.94,2.13-2.94,3.95v53.28c0,2.57-2.33,4.49-4.86,4.05-1.18-.2-2.53-.31-4.22-.31-2.63,0-6.79.52-9.83,1.76-7.59,3.05-11.13,9.99-11.13,16.19s5.11,12.1,16.35,12.1c8.14,0,16.34-5.74,19.51-12.65,1.1-2.47,1.71-7.29,1.71-10.75V31.85c0-1.89,1.29-3.54,3.12-4l23.87-5.95c1.83-.46,3.12-2.11,3.12-4Z" /><rect fill="#fff" x="48.86" y="58.68" width="67.57" height="7.51" rx="2.73" ry="2.73" /><rect fill="#fff" x="48.98" y="39.9" width="67.45" height="7.51" rx="2.73" ry="2.73" /></g></svg>
                <span>Playlists</span>
            </HeaderLayout>

            <div className="master-playlist-list">
                {episodeNumber !== -1 && episodes[episodeNumber].scene[sceneNumber].playlists.map((playlist: IPlaylist, index: number) =>
                    <div className="master-playlist-item" key={index}>
                        <div className="master-playlist-item-icon" dangerouslySetInnerHTML={{ __html: playlist.icon }}>
                        </div>
                        <div className="master-playlist-item-text" onClick={() => onPlaylistBlockClick(playlist)}>
                            <PlainBox fill={activePlaylist && playlist.playlistId === activePlaylist.playlistId ? "#ec6526" : "#fff"} stroke={activePlaylist && playlist.playlistId === activePlaylist.playlistId ? "#fff" : "#ec6526"} />
                            <span className={playlist.className} style={{ color: activePlaylist && playlist.playlistId === activePlaylist.playlistId ? "#fff" : "#ec6526" }}>{playlist.label}</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
